import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { Configuration } from '@/components/modules/ChannelDetail/ChannelDetails/components/Configuration/Configuration';
import { Details } from '@/components/modules/ChannelDetail/ChannelDetails/components/Details';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ModuleCorePermissionProps } from '@/config/types';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const ChannelDetails = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { merchantId, channelId } = useParams();

  if (!merchantId) return null;

  const { merchantStructure } = useGetMerchantStructureById(merchantId);

  if (!merchantStructure) return <PendingDataWarning />;

  const currentChannel = MerchantStructureEntity.create({ merchantStructure, channelId }).getChannel();

  if (!currentChannel) return <PendingDataWarning />;

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <Details currentChannel={currentChannel} />
        <Configuration merchantId={merchantId} currentChannel={currentChannel} editModeAllowed={canEdit} />
      </Box>
    </>
  );
};

export const ChannelDetailsModule = withPermissionsModule(ChannelDetails);
